import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/PageTransition';
import { projectsData } from './data/projectsData';

import Work from './pages/Work';
import About from './pages/About';
import Portfolio from './pages/Portfolio';

import Login from './pages/Login';
import InvoiceGenerator from './components/InvoiceGenerator'; 
import ProtectedRoute from './components/ProtectedRoute';

const DynamicPortfolioRoute = () => {
  const { id } = useParams();
  const project = projectsData.find((p) => String(p.id) === String(id));
  const title = project ? project.title : "Project";

  return (
    <PageTransition title={title}>
      <Portfolio />
    </PageTransition>
  );
};

function AppRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route path="/" element={ <PageTransition title="About"><About /></PageTransition> } />
        <Route path="/work" element={ <PageTransition title="Work"><Work /></PageTransition> } />
        <Route path="/portfolio/:id" element={<DynamicPortfolioRoute />} />
        
        {/* The Login Route */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes Wrapper */}
        <Route element={<ProtectedRoute />}>
          {/* Any route put inside here requires a password */}
          <Route 
            path="/invoice" 
            element={
              <PageTransition title="Invoice">
                <InvoiceGenerator />
              </PageTransition>
            } 
          />
        </Route>

      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <Router>
      
      <div className="min-h-screen bg-gray-50 text-gray-900">
        <Navbar />
        <main>
          <AppRoutes />
        </main>
      </div>
    </Router>
  );
}